import { GatsbyImage, getImage } from "gatsby-plugin-image"

import React from "react"

export const ZoomedImageModal = ({
  zoom_modal,
  set_zoom_modal,
  zoom_image,
}) => {
  const image_data = getImage(zoom_image)
  const close_modal = () => set_zoom_modal(false)
  return (
    <div
      aria-label="Zoom Modal"
      onClick={close_modal}
      onKeyDown={close_modal}
      role="button"
      tabIndex="-1"
      className={`modal ${zoom_modal ? "is-active" : ""}`}
    >
      <div className="modal-background"></div>
      <div
        className="modal-content is-flex"
        style={{ maxHeight: "100%", width: "100%" }}
      >
        <GatsbyImage
          image={image_data}
          alt={zoom_image?.fields?.caption}
          title={zoom_image?.fields?.caption}
          style={{ maxHeight: "100%", cursor: "zoom-out", margin: "auto" }}
          imgStyle={{ objectFit: "contain" }}
        />
      </div>
    </div>
  )
}
